import { handleResponse, handleError } from "../services/serviceUtil";
import ApiService from "../auth/ApiService";

const apiEndpoint = ApiService.API_URL;
const resourceUrl = apiEndpoint + "/secured/role";

const UserRoleAPI = {
  userRoleData: {
    data: []
  },

  all: async function(t) {
    let data = await new ApiService().callApi(`${resourceUrl}`, "get");
    this.userRoleData.data = data.data;
    return this.userRoleData;
  },
  save: async function(userRole) {
    let data = await new ApiService().callApi(`${resourceUrl}`, "post", userRole);
    return data.data;
  },
  getUserRole: async function(userRoleId) {
    return new ApiService()
      .callApi(`${resourceUrl}/${userRoleId}`, "get")
      .then(handleResponse)
      .catch(handleError);
  },
  updateUserRole: function(userRole) {
    return new ApiService()
      .callApi(`${resourceUrl}`, "put", userRole)
      .then(handleResponse)
      .catch(handleError);
  },
  deleteUserRole: function(userRoleId) {
    return new ApiService()
      .callApi(`${resourceUrl}/${userRoleId}`, "delete")
      .then(handleResponse)
      .catch(handleError);
  }
};

export default UserRoleAPI;
